import { render, staticRenderFns } from "./UserVoice.vue?vue&type=template&id=77b3ca45&scoped=true"
import script from "./UserVoice.vue?vue&type=script&lang=js"
export * from "./UserVoice.vue?vue&type=script&lang=js"
import style0 from "./UserVoice.vue?vue&type=style&index=0&id=77b3ca45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b3ca45",
  null
  
)

export default component.exports